import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=afaa5c26&"
import script from "./feedback.vue?vue&type=script&lang=js&"
export * from "./feedback.vue?vue&type=script&lang=js&"
import style0 from "./feedback.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afaa5c26')) {
      api.createRecord('afaa5c26', component.options)
    } else {
      api.reload('afaa5c26', component.options)
    }
    module.hot.accept("./feedback.vue?vue&type=template&id=afaa5c26&", function () {
      api.rerender('afaa5c26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/msg/feedback.vue"
export default component.exports